import Slice9Button from "../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Button";

/**
 * Slice 9 button variant with an icon on the left.
 */
export default class IconSlice9Button extends Slice9Button {
    setLabel(string) {
        this._label = string || "";
        //Set label string in each state movieclip that has a Text instance named textfield
        var states = this._states;
        for (var i = 0; i < states.length; i++)
        {
            var state = states[i];
            if (this.skin[state])
            {
                var instance = this.skin[state];
                var tf = instance.textfield;
                if (tf) tf.text = this._label;

                const icon = instance.icon;
                if (icon) {
                    icon.x = tf.getBounds().x - 5;
                }

                instance.sliced.update();
            }
        }
        this._setState(this._state);
    }
}